const showcaseYoutube11132024 = "W7asMiNSEs4";
const showcaseYoutube02052025 = "I_OpBdOVA5Y";
const showcaseYoutube04232025 = "4jI0sPQ19Cg";
const showcaseYoutube07162025 = "9z1SN6yAlRI";

function timeStringToSeconds(timeStr) {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

export const showcasePresentersData = [
  {
    presenterName: "Oubada Hawass",
    presenterRole: "Founder and CTO",
    orgName: "Aerial X Firefighting Inc.",
    orgDescription:
      "Deliver All Ground Suppression Capabilities by Air Where Crews Can’t Go",
    linkedinPersonal: "https://www.linkedin.com/in/oubada-hawass-43426183/",
    presenterPhoto: "/assets/showcase-presentations-assets/oubada-hawass.png",
    orgLogo: "/assets/showcase-presentations-assets/aerialx.jpg",
    location: "Toronto, ON, Canada",
    youtube: {
      id: showcaseYoutube07162025,
      start: timeStringToSeconds("0:30:41"),
      end: timeStringToSeconds("0:42:28"),
    },
    video: "",
    videoPreview:
      "/assets/showcase-presentations-assets/aerialx-preview-07162025.jpg",
    slides:
      "/assets/showcase-presentations-assets/oubada-hawass-aerialx-slides-07162025.pdf",
    showcaseDate: "07162025",
    display: true,
  },
  {
    presenterName: "Troy Helming",
    presenterRole: "Founder and CEO",
    orgName: "EarthGrid PBC",
    orgDescription:
      "Our TBR creates a clean, underground bore with minimal surface footprint, reducing excavation and environmental impact.",
    linkedinPersonal: "https://www.linkedin.com/in/troyhelming/",
    linkedin: "https://linkedin.com/company/earthgrid-io",
    presenterPhoto: "/assets/showcase-presentations-assets/troy-helming.jpg",
    orgLogo: "/assets/showcase-presentations-assets/earth-grid.png",
    location: "Richmond, CA, USA",
    youtube: {
      id: showcaseYoutube07162025,
      start: timeStringToSeconds("00:43:00"),
      end: timeStringToSeconds("00:55:15"),
    },
    video: "",
    videoPreview:
      "/assets/showcase-presentations-assets/earthgrid-preview-07162025.jpg",
    slides:
      "/assets/showcase-presentations-assets/troy-helming-earthgrid-slides-07162025.pdf",
    showcaseDate: "07162025",
    display: true,
  },
  {
    orgName: "Team Wildfire",
    orgLogo: "/assets/showcase-presentations-assets/teamwildfire_logo.png",
    presenterName: "Steve Wolf",
    presenterRole: "Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/steve-wolf.jpg",
    orgDescription:
      "We use jet engines to drive back fires, strip fuels, and apply retardant.",
    location: "Boulder, CO, USA",
    linkedinPersonal: "https://linkedin.com/in/wolfsteve",
    linkedin: "https://www.linkedin.com/company/teamwildfire",
    video: "",
    videoPreview:
      "/assets/showcase-presentations-assets/teamwildfire-preview-07162025.jpg",
    youtube: {
      id: showcaseYoutube07162025,
      start: timeStringToSeconds("1:06:31"),
      end: timeStringToSeconds("1:21:31"),
    },
    slides:
      "/assets/showcase-presentations-assets/steve-wolf-team-wildfire-slides-07162025.pdf",
    category: "",
    showcaseDate: "07162025",
    display: true,
  },
  {
    orgName: "Flara",
    orgLogo: "/assets/showcase-presentations-assets/flara.jpg",
    presenterName: "Preet Anand",
    presenterRole: "Co-Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/preet-anand.jpeg",
    orgDescription:
      "FLARA.me by Snug Products LLC uses AI to give homeowners fast, personalized wildfire hardening advice, cutting inspection times from weeks to minites to help protect lives and property",
    location: "Oakland, CA, USA",
    linkedinPersonal: "https://www.linkedin.com/in/pr33t",
    linkedin: "",
    video: "",
    videoPreview:
      "/assets/showcase-presentations-assets/flara-preview-07162025.jpg",
    youtube: {
      id: showcaseYoutube07162025,
      start: timeStringToSeconds("1:21:34"),
      end: timeStringToSeconds("1:34:23"),
    },
    slides:
      "/assets/showcase-presentations-assets/preet-anand-flara-slides-07162025.pdf",
    category: "",
    showcaseDate: "07162025",
    display: true,
  },
  {
    orgName: "Sonic Fire Tech",
    orgLogo: "/assets/showcase-presentations-assets/sonic-fire-tech.png",
    presenterName: "Geoff Bruder",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/geoff-bruder.jpeg",
    orgDescription:
      "Sonic Fire Tech uses patented acoustic wave technology to safely and sustainably extinguish fires without water or chemicals, making it ideal for wildfire response, drone deployment, and high-value infrastructure protection.",
    location: "Rocky River, OH, USA",
    linkedinPersonal: "https://www.linkedin.com/in/geoffreybruder/",
    linkedin: "https://www.linkedin.com/company/sonic-fire-tech/",
    video: "",
    videoPreview:
      "/assets/showcase-presentations-assets/sonicfiretech-preview-07162025.jpg",
    youtube: {
      id: showcaseYoutube07162025,
      start: timeStringToSeconds("1:34:33"),
      end: timeStringToSeconds("1:45:13"),
    },
    slides:
      "/assets/showcase-presentations-assets/geoff-bruder-sonicfiretech-slides-07162025.pdf",
    category: "",
    showcaseDate: "07162025",
    display: true,
  },
  {
    presenterName: "Christopher Jones",
    presenterRole: "CEO",
    orgName: "Conversa Corps, Incorporated",
    orgDescription:
      "Help the wildfire community converse and collaborate, everyday, every fire, online, live.",
    linkedinPersonal: "https://www.linkedin.com/in/goaskjonesy/",
    linkedin: "https://www.linkedin.com/company/conversacorps",
    presenterPhoto: "/assets/showcase-presentations-assets/chris-jones.jpg",
    orgLogo: "/assets/showcase-presentations-assets/conversa.png",
    location: "Denver, CO, USA",
    youtube: {
      id: showcaseYoutube07162025,
      start: timeStringToSeconds("00:55:32"),
      end: timeStringToSeconds("01:06:18"),
    },
    video: "",
    videoPreview:
      "/assets/showcase-presentations-assets/conversa-preview-07162025.jpg",
    slides:
      "/assets/showcase-presentations-assets/christopher-jones-conversa-slides-07162025.pdf",
    showcaseDate: "07162025",
    display: true,
  },

  {
    presenterName: "Amogha Srirangarajan",
    presenterRole: "Founder and CEO",
    orgName: "Carbon Origins Inc.",
    orgDescription:
      "AI‑powered skid‑steer robot that detects and attacks fires in seconds, protecting critical infrastructure while keeping firefighters safe.",
    linkedinPersonal: "https://www.linkedin.com/in/amoghaio/",
    linkedin: "https://www.linkedin.com/company/carbon-origins",
    presenterPhoto:
      "/assets/showcase-presentations-assets/amogha-srirangarajan.jpg",
    orgLogo: "/assets/showcase-presentations-assets/carbon-origins.png",
    location: "San Francisco, CA, USA",
    youtube: {
      id: showcaseYoutube07162025,
      start: timeStringToSeconds("1:45:35"),
      end: timeStringToSeconds("1:59:07"),
    },
    video: "",
    videoPreview:
      "/assets/showcase-presentations-assets/carbon-origins-preview.jpg",
    slides: "", // no slides provided
    showcaseDate: "07162025",
    display: true,
  },
  {
    orgName: "WUUII",
    orgLogo: "/assets/showcase-presentations-assets/wuuii.png",
    presenterName: "Ivan O'Neil",
    presenterRole: "Co-Founder",
    presenterPhoto: "/assets/showcase-presentations-assets/ivan-oneil.jpg",
    orgDescription:
      "Wuuii solves the entire customer journey from discovery to action to ongoing verification.  Our self-inspection app reduces the cost and time of insurance inspections by 90% and our network of vetted contractors ensures property owners get value and quality work done quickly to comply with their insurer's underwriting requirements.",
    location: "Santa Rosa, CA, USA",
    linkedinPersonal: "https://www.linkedin.com/in/ivanoneill/ ",
    linkedin: "https://www.linkedin.com/company/madronus/",
    video:
      "/assets/showcase-presentations-assets/ivan-oneil-wuuii-04-23-2025.mp4",
    youtube: {
      id: "9z1SN6yAlRI",
      start: timeStringToSeconds("0:14:44"),
      end: timeStringToSeconds("0:27:09"),
    },
    videoPreview:
      "/assets/showcase-presentations-assets/ivan-oneil-wuuii-preview.jpg",
    slides: "",
    category: "",
    showcaseDate: "04232025",
    display: true,
  },
  {
    orgName: "BoxPower",
    orgLogo: "/assets/showcase-presentations-assets/box-power.png",
    presenterName: "Shawn Burns",
    presenterRole: "Business Development & Strategic Growth",
    presenterPhoto: "/assets/showcase-presentations-assets/shawn-burns.jpg",
    orgDescription:
      "BoxPower delivers standardized, turnkey microgrids that simplify deployment of clean, resilient power for wildfire mitigation and remote energy access. BoxPower provides clean, reliable, and affordable energy to rural consumers.",
    location: "Grass Valey, CA, USA",
    linkedinPersonal: "",
    linkedin: "https://www.linkedin.com/company/boxpower/",
    video:
      "/assets/showcase-presentations-assets/shawn-burns-boxpower-04-23-2025.mp4",
    youtube: {
      id: showcaseYoutube07162025,
      start: timeStringToSeconds("0:27:37"),
      end: timeStringToSeconds("0:42:13"),
    },
    videoPreview:
      "/assets/showcase-presentations-assets/shawn-burns-box-power-preview.jpg",
    slides: "/assets/showcase-presentations-assets/shawn-burns-box-power.pdf",
    category: "",
    showcaseDate: "04232025",
    display: true,
  },
  {
    orgName: "Maggies Farm",
    orgLogo: "/assets/showcase-presentations-assets/maggies-farm.png",
    presenterName: "Eamonn Glass",
    presenterRole: "Co-Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/eamonn-glass.png",
    orgDescription:
      "FIRE is a four player co-operative video game where players must work together to battle apocalyptic wildfires using advanced technologies and innovations.",
    location: "Vancouver, Canada",
    linkedinPersonal: "https://www.linkedin.com/in/eamonnglass",
    linkedin: "",
    video:
      "/assets/showcase-presentations-assets/eamonn-glass-maggies-farm-04-23-2025.mp4",
    youtube: {
      id: showcaseYoutube04232025,
      start: timeStringToSeconds("0:42:14"),
      end: timeStringToSeconds("1:03:00"),
    },
    videoPreview:
      "/assets/showcase-presentations-assets/eamonn-glass-maggies-farm-preview.jpg",
    slides:
      "/assets/showcase-presentations-assets/eamonn-glass-maggies-farm.pdf",
    category: "",
    showcaseDate: "04232025",
    display: true,
  },
  {
    orgName: "TreeTrack",
    orgLogo: "/assets/showcase-presentations-assets/tree-track.png",
    presenterName: "Amir Soleimani",
    presenterRole: "Co-Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/amir-soleimani.jpg",
    orgDescription:
      "TreeTrack restores forests using UAV-deployed Seedpods with 55% success, delivering scalable reforestation and real-time environmental impact data.",
    location: "British Columbia, Canada",
    linkedinPersonal: "https://www.linkedin.com/in/amirsoleimani1/",
    linkedin: "https://www.linkedin.com/company/treetrack/",
    video:
      "/assets/showcase-presentations-assets/amir-suleimani-treetrack-04-23-2025.mp4",
    youtube: {
      id: showcaseYoutube04232025,
      start: timeStringToSeconds("1:03:18"),
      end: timeStringToSeconds("1:15:18"),
    },
    videoPreview:
      "/assets/showcase-presentations-assets/amir-soleimani-tree-track-preview.jpg",
    slides:
      "/assets/showcase-presentations-assets/amir-soleimani-tree-track.pdf",
    category: "",
    showcaseDate: "04232025",
    display: true,
  },
  {
    orgName: "Wildfire Innovations, Inc.",
    orgLogo:
      "/assets/showcase-presentations-assets/rain-stream-wildfire-innovations.png",
    presenterName: "Rolf Wenzel",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/rolf-wenzel.jpg",
    orgDescription:
      "RainStream™ World's first mobile rain tower. Patent pending and best combination of large area water coverage and rapid deployment in WUI wildfires from hydrant, ponds or rivers.  Can protect dozens of houses with a single hydrant.",
    location: "",
    linkedinPersonal: "https://www.linkedin.com/in/58dg33124567352/",
    linkedin: "https://www.linkedin.com/company/rainstreamwildfire/",
    video:
      "/assets/showcase-presentations-assets/rolf-wenzel-rainstream-04-23-2025.mp4",
    youtube: {
      id: showcaseYoutube04232025,
      start: timeStringToSeconds("1:15:30"),
      end: timeStringToSeconds("1:29:25"),
    },
    videoPreview:
      "/assets/showcase-presentations-assets/rolf-wenzel-rainstream-preview.jpg",
    slides: "",
    category: "",
    showcaseDate: "04232025",
    display: true,
  },
  {
    orgName: "Inferno Roll Shutters",
    orgLogo: "/assets/showcase-presentations-assets/inferno-roll-shutters.png",
    presenterName: "David Horobin",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/david-horobin.jpg",
    orgDescription:
      "Inferno-Roll shutters are high-performance, fire-resistant roller shutters that protect homes from wildfires and hurricanes. Built from fire-rated materials, they shield windows and doors—the most vulnerable points—from flames, embers, and heat damage. With a sleek roll-up design, they offer discreet, effective defense without sacrificing curb appeal.",
    location: "Chandler, AZ, USA",
    linkedinPersonal: "",
    linkedin: "",
    video:
      "/assets/showcase-presentations-assets/david-horobin-inferno-roll-shutters-04-23-2025.mp4",
    youtube: {
      id: showcaseYoutube04232025,
      start: timeStringToSeconds("1:29:30"),
      end: timeStringToSeconds("1:43:08"),
    },
    videoPreview:
      "/assets/showcase-presentations-assets/david-horobin-inferno-roller-shutters-preview-04232025.jpg",
    slides: "",
    category: "",
    showcaseDate: "04232025",
    display: true,
  },
  {
    orgName: "FiorEarth",
    orgLogo: "/assets/showcase-presentations-assets/fior-earth.png",
    presenterName: "John Buethe",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/john-buethe.jpg",
    orgDescription:
      "FiorEarth has developed BarriEarth, a patent-pending erosion control product made from 100% sustainable, locally sourced materials. This innovative solution resists wildfires, remediates ecosystems, and sequesters carbon.",
    location: "Oceanside, CA, USA",
    linkedinPersonal: "https://www.linkedin.com/in/johnmbuethe/",
    linkedin: "",
    video:
      "/assets/showcase-presentations-assets/john-buethe-fiorearth-04-23-2025.mp4",
    youtube: {
      id: showcaseYoutube04232025,
      start: timeStringToSeconds("1:43:30"),
      end: timeStringToSeconds("1:57:41"),
    },
    videoPreview:
      "/assets/showcase-presentations-assets/john-buethe-fior-earth-preview.jpg",
    slides: "/assets/showcase-presentations-assets/john-buethe-fior-earth.pdf",
    category: "",
    showcaseDate: "04232025",
    display: true,
  },
  {
    orgName: "FireDome",
    orgLogo: "/assets/showcase-presentations-assets/fire-dome.gif",
    presenterName: "Gadi Benjamini",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/gadi-benjamini.jpg",
    orgDescription:
      "FireDome offers wildfire resiliency-as-a-service, protecting communities and assets at risk with a mechanical launcher that deploys fire retardant capsules...",
    location: "Israel",
    linkedinPersonal: "https://www.linkedin.com/in/gadi-benjamini-a5544520a/",
    linkedin: "https://www.linkedin.com/company/105729447/",
    video: "/assets/showcase-presentations-assets/fire-dome.mp4",
    videoPreview: "/assets/showcase-presentations-assets/fire-dome-preview.jpg",
    youtube: {
      id: showcaseYoutube02052025,
      start: timeStringToSeconds("0:19:50"),
      end: timeStringToSeconds("0:35:35"),
    },
    slides:
      "/assets/showcase-presentations-assets/fire-dome-gadi-benjamini.pdf",
    category: "",
    showcaseDate: "02052025",
    display: true,
  },
  {
    orgName: "Dryad",
    orgLogo: "/assets/showcase-presentations-assets/dryad.webp",
    presenterName: "Carsten Brinkschulte",
    presenterRole: "CEO",
    presenterPhoto:
      "/assets/showcase-presentations-assets/carsten-brinkschulte.jpg",
    orgDescription:
      "Dryad dramatically reduces reaction time for wildfires with solar-powered gas-sensors in a large-scale IoT network.",
    location: "Berlin, Germany",
    linkedinPersonal: "https://www.linkedin.com/in/brinkschulte",
    linkedin: "https://www.linkedin.com/company/dryadnetworks",
    video: "/assets/showcase-presentations-assets/dryad.mp4",
    videoPreview: "/assets/showcase-presentations-assets/dryad-preview.jpg",
    youtube: {
      id: showcaseYoutube02052025,
      start: timeStringToSeconds("0:35:38"),
      end: timeStringToSeconds("0:49:03"),
    },
    slides:
      "/assets/showcase-presentations-assets/dryad-carsten-brinkschulte.pdf",
    category: "",
    showcaseDate: "02052025",
    display: true,
  },
  {
    orgName: "FireFlocks",
    orgLogo: "/assets/showcase-presentations-assets/fire-flocks.png",
    presenterName: "Jordi Vendrell",
    presenterRole: "General Manager",
    presenterPhoto: "/assets/showcase-presentations-assets/jordi-vendrell.jpg",
    orgDescription:
      "Fire Flocks uses extensive livestock farming to reduce wildfire risk and enhance forest management...",
    location: "Chheu Teal, Cambodia",
    linkedinPersonal: "https://www.linkedin.com/in/vendrelljordi/",
    linkedin: "https://www.linkedin.com/company/pau-costa-foundation/",
    video: "",
    videoPreview:
      "/assets/showcase-presentations-assets/fire-flocks-preview.jpg",
    youtube: "",
    slides:
      "/assets/showcase-presentations-assets/fireflocks-jordi-vendrell.pdf",
    category: "",
    showcaseDate: "02052025",
    display: false,
  },
  {
    orgName: "Clore",
    orgLogo: "/assets/showcase-presentations-assets/clore.webp",
    presenterName: "Barrett Deng",
    presenterRole: "Chief Operating Officer",
    presenterPhoto: "/assets/showcase-presentations-assets/barrett-deng.jpg",
    orgDescription:
      "Clore’s fire retardant coats flammable vegetation making it unable to burn when it comes in contact with a wildfire.",
    location: "Mountain View, CA, USA",
    linkedinPersonal: "",
    linkedin: "https://www.linkedin.com/company/clorefr",
    video: "/assets/showcase-presentations-assets/clore.mp4",
    videoPreview: "/assets/showcase-presentations-assets/clore-preview.jpg",
    youtube: {
      id: showcaseYoutube02052025,
      start: timeStringToSeconds("0:49:12"),
      end: timeStringToSeconds("1:03:55"),
    },
    slides:
      "/assets/showcase-presentations-assets/barrett-deng-sebastien-burkhardt-clore.pdf",
    category: "",
    showcaseDate: "02052025",
    display: true,
  },
  {
    orgName: "Trident Sensing",
    orgLogo: "/assets/showcase-presentations-assets/trident-sensing.png",
    presenterName: "Steve Pollard",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/steve-pollard.png",
    orgDescription:
      "TACFI-RS is a mapping system that collects wildfire data in a networked, multi-platform environment...",
    location: "Salt Lake City, UT, USA",
    linkedinPersonal: "https://www.linkedin.com/in/steve-pollard-b03b27b",
    linkedin:
      "https://www.linkedin.com/company/tridentsensing/posts/?feedView=all",
    video: "/assets/showcase-presentations-assets/trident-sensing.mp4",
    videoPreview:
      "/assets/showcase-presentations-assets/trident-sensing-preview.jpg",
    youtube: {
      id: showcaseYoutube02052025,
      start: timeStringToSeconds("1:04:17"),
      end: timeStringToSeconds("1:16:25"),
    },
    slides:
      "/assets/showcase-presentations-assets/trident-sensing-steve-pollard.pdf",
    category: "",
    showcaseDate: "02052025",
    display: true,
  },
  {
    orgName: "Climformatics",
    orgLogo: "/assets/showcase-presentations-assets/climformatics.png",
    presenterName: "Subarna Bhattacharyya",
    presenterRole: "Co-Founder and CEO",
    presenterPhoto:
      "/assets/showcase-presentations-assets/subarna-bhattacharyya-sq.jpg",
    orgDescription:
      "Climformatics predicts localized climate, fire weather, solar power, and net load a year ahead in advance to prepare & protect utilities...",
    location: "Fremont, CA, USA",
    linkedinPersonal: "https://www.linkedin.com/in/subarna-bhattacharyya/",
    linkedin: "https://www.linkedin.com/company/climformatics-inc/",
    video: "/assets/showcase-presentations-assets/crimformatics.mp4",
    videoPreview:
      "/assets/showcase-presentations-assets/climformatics-preview.jpg",
    youtube: {
      id: showcaseYoutube02052025,
      start: timeStringToSeconds("1:16:44"),
      end: timeStringToSeconds("1:29:23"),
    },
    slides:
      "/assets/showcase-presentations-assets/climformatics-subarna-bhattacharyya.pdf",
    category: "",
    showcaseDate: "02052025",
    display: true,
  },
  {
    orgName: "HiberTec Homes",
    orgLogo: "/assets/showcase-presentations-assets/hibertec-bl.png",
    presenterName: "Holden Forrest",
    presenterRole: "Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/holden-forrest.jpg",
    orgDescription:
      "HiberTec protects homes from wildfires by lowering them underground via smartphone control...",
    location: "Culver City, CA, USA",
    linkedinPersonal: "https://www.linkedin.com/in/holden-forrest-55a955115/",
    linkedin: "",
    video: "/assets/showcase-presentations-assets/hiber-tec-feb-2025.mp4",
    videoPreview: "/assets/showcase-presentations-assets/hiber-tec-preview.jpg",
    youtube: {
      id: showcaseYoutube02052025,
      start: timeStringToSeconds("1:30:13"),
      end: timeStringToSeconds("1:44:16"),
    },
    slides: "/assets/showcase-presentations-assets/hibertec-ace-tarakchian.pdf",
    category: "",
    showcaseDate: "02052025",
    display: true,
  },
  {
    orgName: "Fire Swarm Solutions",
    orgLogo: "/assets/showcase-presentations-assets/fire-swarm-bl.png",
    presenterName: "Alex Deslauriers",
    presenterRole: "CEO",
    presenterPhoto:
      "/assets/showcase-presentations-assets/alex-deslauriers.jpg",
    orgDescription:
      "FireSwarm Solutions provides an automated aerial fire suppression platform using heavy-lift technology...",
    location: "Garibaldi Highlands, BC, Canada",
    linkedinPersonal: "",
    linkedin: "",
    video: "/assets/showcase-presentations-assets/fire-swarm.mp4",
    videoPreview:
      "/assets/showcase-presentations-assets/fire-swarm-preview.jpg",
    youtube: {
      id: showcaseYoutube02052025,
      start: timeStringToSeconds("1:44:26"),
      end: timeStringToSeconds("1:55:55"),
    },
    slides:
      "/assets/showcase-presentations-assets/alex-deslauriers-fire-swarm.pdf",
    category: "",
    showcaseDate: "02052025",
    display: true,
  },
  {
    orgName: "Improving Aviation",
    orgLogo: "/assets/showcase-presentations-assets/improving-aviation-bl.png",
    presenterName: "Jake Rosenzweig",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/jake-rosenzweig.jpg",
    orgDescription:
      "Improving Aviation's platforms, like WindTL, leverage expertise in environmental modeling, wildfire detection, mobility, response, and airspace management...",
    location: "Tampa, FL, USA",
    linkedinPersonal: "https://www.linkedin.com/in/jakerosenzweig/",
    linkedin: "https://www.linkedin.com/company/improving-aviation-llc/",
    video: "/assets/showcase-presentations-assets/improving-aviation.mp4",
    videoPreview:
      "/assets/showcase-presentations-assets/improving-aviation-preview.jpg",
    youtube: {
      id: showcaseYoutube02052025,
      start: timeStringToSeconds("1:56:17"),
      end: timeStringToSeconds("2:07:57"),
    },
    slides: "/assets/showcase-presentations-assets/jake-rosenzweig.pdf",
    category: "",
    showcaseDate: "02052025",
    display: true,
  },
  {
    orgName: "SpaceCrete Technologies",
    orgLogo: "/assets/showcase-presentations-assets/space-crete-tech.png",
    presenterName: "Michael Butler",
    presenterRole: "Civil Engineer / Product Development",
    presenterPhoto: "/assets/showcase-presentations-assets/michael-butler.jpg",
    orgDescription:
      "Spacecrete combines normal concrete with 3D-AdmixTM to enable rapid slip forming and 3D printing...",
    location: "",
    linkedinPersonal: "https://www.linkedin.com/in/michael-butler-53a03b147/",
    linkedin: "",
    video: "",
    videoPreview: "",
    youtube: "",
    slides: "/assets/showcase-presentations-assets/space-crete.pdf",
    category: "",
    showcaseDate: "02052025",
    display: false,
  },
  {
    orgName: "N5 Sensors",
    orgLogo: "/assets/showcase-presentations-assets/n5.png",
    presenterName: "Debra Deininger",
    presenterRole: "CRO",
    presenterPhoto: "/assets/showcase-presentations-assets/debra-deininger.jpg",
    orgDescription:
      "Automated and autonomous N5SHIELD uses gas, chemical and particulate sensors to accurately detect and locate fires.",
    location: "Rockville, MD, USA",
    linkedinPersonal: "https://www.linkedin.com/in/debrajdeininger/",
    linkedin: "https://www.linkedin.com/company/n5-sensors-inc-",
    video: "/assets/showcase-presentations-assets/N5.mp4",
    videoPreview:
      "/assets/showcase-presentations-assets/n5-sensors-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("0:33:15"),
      end: timeStringToSeconds("0:43:44"),
    },
    slides: "/assets/showcase-presentations-assets/n5-debra-deininger.pdf",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },
  {
    orgName: "Skyseed",
    orgLogo: "/assets/showcase-presentations-assets/skyseed.png",
    presenterName: "Ole Seidenberg",
    presenterRole: "Co-Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/ole-seidenberg.jpg",
    orgDescription:
      "We rebuild resilient forest-ecosystems by direct seeding herbs, shrubs and trees, protecting them with our patented pellet technology.",
    location: "Berlin, Germany",
    linkedinPersonal: "https://www.linkedin.com/in/ole-seidenberg/",
    linkedin: "https://www.linkedin.com/company/skyseed",
    video: "/assets/showcase-presentations-assets/Skyseed.mp4",
    videoPreview: "/assets/showcase-presentations-assets/skyseed-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("0:44:09"),
      end: timeStringToSeconds("0:54:43"),
    },
    slides: "/assets/showcase-presentations-assets/ole-seidenberg.pdf",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },

  {
    orgName: "ACC Innovation AB",
    orgLogo: "/assets/showcase-presentations-assets/acc.png",
    presenterName: "Max Drougge",
    presenterRole: "CTO",
    presenterPhoto: "/assets/showcase-presentations-assets/max-drougge.jpg",
    orgDescription:
      "Firefighting by using a standard bambi-bucket or other required equipment – which can be performed in swarms.",
    location: "Åtvidaberg, Sweden",
    linkedinPersonal: "",
    linkedin: "https://www.linkedin.com/company/acc-innovation/",
    video: "/assets/showcase-presentations-assets/ACC.mp4",
    videoPreview: "/assets/showcase-presentations-assets/acc-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("0:56:17"),
      end: timeStringToSeconds("1:08:06"),
    },
    slides: "/assets/showcase-presentations-assets/acc-max-drougge.pdf",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },

  {
    orgName: "Wildflyer",
    orgLogo: "/assets/showcase-presentations-assets/wildflyer-bl.png",
    presenterName: "Daan Aerts",
    presenterRole: "Founder",
    presenterPhoto: "/assets/showcase-presentations-assets/daan-aerts.jpg",
    orgDescription:
      "Wildflyer offers a data aggregation and analysis application perfectly adapted to the missions of fire management teams.",
    location: "Middelie, Netherlands",
    linkedinPersonal: "http://www.linkedin.com/in/daan-aerts-6667666b/",
    linkedin: "http://www.linkedin.com/company/wildflyer",
    video: "/assets/showcase-presentations-assets/Wildflyer.mp4",
    videoPreview: "/assets/showcase-presentations-assets/wildflyer-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("1:08:30"),
      end: timeStringToSeconds("1:20:01"),
    },
    slides: "/assets/showcase-presentations-assets/dean-aerts.pdf",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },

  {
    orgName: "Faura",
    orgLogo: "/assets/showcase-presentations-assets/faura.png",
    presenterName: "Valkyrie Holmes",
    presenterRole: "Co-Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/valkyrie-holmes.jpg",
    orgDescription:
      "We help insurance companies find more profitable business in wildfire-prone areas and help policyholder reduce their risk and stay profitable.",
    location: "New York, NY, USA",
    linkedinPersonal: "https://www.linkedin.com/in/valkyrieholmes/",
    linkedin: "https://www.linkedin.com/company/faurainc/",
    video: "/assets/showcase-presentations-assets/faura.mp4",
    videoPreview: "/assets/showcase-presentations-assets/faura-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("1:20:23"),
      end: timeStringToSeconds("1:31:38"),
    },
    slides: "",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },
  {
    orgName: "Solaris Suborbital",
    orgLogo: "/assets/showcase-presentations-assets/solaris-suborbital.jpg",
    presenterName: "Daniel Doulton",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/daniel-doulton.jpg",
    orgDescription:
      "Solaris provides you with the world’s most powerful situational awareness with its live earth streams from over any spot in the world...",
    location: "San Francisco, CA, USA",
    linkedinPersonal: "",
    linkedin: "https://www.linkedin.com/company/solaris-suborbital",
    video: "/assets/showcase-presentations-assets/",
    videoPreview:
      "/assets/showcase-presentations-assets/daniel-doulton-solaris-suborbital.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("1:33:11"),
      end: timeStringToSeconds("1:45:46"),
    },
    slides: "/assets/showcase-presentations-assets/solaris-daniel-doulton.pdf",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },

  {
    orgName: "Wildfire Innovations, Inc.",
    orgLogo:
      "/assets/showcase-presentations-assets/rain-stream-wildfire-innovations.png",
    presenterName: "Rolf Wenzel",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/rolf-wenzel.jpg",
    orgDescription:
      "RainStream™ World's first mobile rain tower. Patent pending and best combination of large area water coverage and rapid deployment in WUI wildfires from hydrant, ponds or rivers...",
    location: "",
    linkedinPersonal: "https://www.linkedin.com/in/58dg33124567352/",
    linkedin: "https://www.linkedin.com/company/rainstreamwildfire/",
    video: "/assets/showcase-presentations-assets/",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("1:46:10"),
      end: timeStringToSeconds("1:57:21"),
    },
    videoPreview:
      "/assets/showcase-presentations-assets/rolf-wenzel-rainstream-preview.jpg",
    slides: "",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },

  {
    orgName: "Strongwater Tech",
    orgLogo: "/assets/showcase-presentations-assets/strong-water.png",
    presenterName: "Jeffrey Denholm",
    presenterRole: "Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/jeff-denholm.jpg",
    orgDescription:
      "Eco friendly, non-carinogenic, water enhancement technology that increases water suppression capacity by 10 X.",
    location: "Santa Cruz, CA, USA",
    linkedinPersonal: "https://www.linkedin.com/in/jeff-denholm-748a4238/",
    linkedin: "",
    video: "/assets/showcase-presentations-assets/StrongWaterTech.mp4",
    videoPreview:
      "/assets/showcase-presentations-assets/strongwater-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("1:59:36"),
      end: 7936,
    },
    slides:
      "/assets/showcase-presentations-assets/strongwatertech-jeffrey-denholm.pdf",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },

  {
    orgName: "Fire Neural Network",
    orgLogo: "/assets/showcase-presentations-assets/fire-neural-network-bg.png",
    presenterName: "Istvan Kereszy",
    presenterRole: "Co-Founder and Chief Resilience Officer",
    presenterPhoto: "/assets/showcase-presentations-assets/istvan-kereszy.jpg",
    orgDescription:
      "Fire Neural Network (FNN) detects lightning initiated fires in seconds. By using satellite data, implementing FNN's proprietary lightning detectors, UAV FireBird, and unleashing the power of artificial intelligence using signal processing tools from astrophysics, Fire Neural Network delivers actionable intelligence in real-time.",
    location: "Gainesville, FL, USA",
    linkedinPersonal: "https://www.linkedin.com/in/ikereszyfnn/",
    linkedin: "https://www.linkedin.com/company/fireneuralnetwork",
    video: "/assets/showcase-presentations-assets/FNN.mp4",
    videoPreview:
      "/assets/showcase-presentations-assets/fire-neural-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("2:12:17"),
      end: timeStringToSeconds("2:23:54"),
    },
    slides:
      "/assets/showcase-presentations-assets/fire-neural-network-deck-caroline-comeau.pdf",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },
  {
    orgName: "Vibrant Planet",
    orgLogo: "/assets/showcase-presentations-assets/vibrant-planet.png",
    presenterName: "Scott Conway",
    presenterRole: "Co-Founder and Chief Resilience Officer",
    presenterPhoto: "/assets/showcase-presentations-assets/scott-conway.jpg",
    orgDescription:
      "We help partners collaborate and identify wildfire mitigation treatments that most efficiently reduce risk.",
    location: "Truckee, CA, USA",
    linkedinPersonal: "https://www.linkedin.com/in/scott-conway-25748a176/",
    linkedin: "https://www.linkedin.com/company/vibrant-planet/",
    video: "/assets/showcase-presentations-assets/VibrantPlanet.mp4",
    videoPreview:
      "/assets/showcase-presentations-assets/vibrant-planet-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("2:24:38"),
      end: timeStringToSeconds("2:31:33"),
    },
    slides:
      "/assets/showcase-presentations-assets/scott-conway-vibrant-planet.pdf",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },
  {
    orgName: "Team Wildfire",
    orgLogo: "/assets/showcase-presentations-assets/teamwildfire_logo.png",
    presenterName: "Steve Wolf",
    presenterRole: "Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/steve-wolf.jpg",
    orgDescription:
      "We use jet engines to drive back fires, strip fuels, and apply retardant.",
    location: "Boulder, CO, USA",
    linkedinPersonal: "https://linkedin.com/in/wolfsteve",
    linkedin: "https://www.linkedin.com/company/teamwildfire",
    video: "/assets/showcase-presentations-assets/TeamWildfire.mp4",
    videoPreview:
      "/assets/showcase-presentations-assets/team-wildfire-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("2:34:20"),
      end: timeStringToSeconds("2:41:20"),
    },
    slides: "/assets/showcase-presentations-assets/team-steve-wolf.pdf",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },

  {
    orgName: "Inferno Roll Shutters",
    orgLogo: "/assets/showcase-presentations-assets/inferno-roll-shutters.png",
    presenterName: "David Horobin",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/david-horobin.jpg",
    orgDescription:
      "Inferno-Roll shutters are high-performance, fire-resistant roller shutters that protect homes from wildfires and hurricanes. Built from fire-rated materials, they shield windows and doors—the most vulnerable points—from flames, embers, and heat damage. With a sleek roll-up design, they offer discreet, effective defense without sacrificing curb appeal.",
    location: "Chandler, AZ, USA",
    linkedinPersonal: "",
    linkedin: "",
    video: "/assets/showcase-presentations-assets/",
    videoPreview:
      "/assets/showcase-presentations-assets/david-horobin-inferno-roll-shutters-preview.jpg",
    youtube: {
      id: "W7asMiNSEs4",
      start: timeStringToSeconds("2:49:09"),
      end: timeStringToSeconds("2:54:43"),
    },
    slides: "",
    category: "",
    showcaseDate: "11172024",
    display: true,
  },

  //////////////////////////////////////////////////////////////////////////////////

  {
    orgName: "Prometheus Space Technologies",
    orgLogo: "/assets/showcase-presentations-assets/prometheus.png",
    presenterName: "Eleftherios Plafountzis",
    presenterRole: "CEO",
    presenterPhoto: "", // not provided
    orgDescription: "",
    location: "",
    linkedinPersonal: "",
    linkedin: "",
    video: "",
    videoPreview: "",
    slides:
      "/assets/showcase-presentations-assets/prometheus-eleftherios-plafountzis.pdf",
    category: "",
    showcaseDate: "11172024", //Nov 17, 2024
  },
  {
    orgName: "Previsionsoft",
    orgLogo: "",
    presenterName: "Josephine Ou",
    presenterRole: "CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/josephine-ou.jpg",
    orgDescription: "",
    location: "",
    linkedinPersonal: "https://www.linkedin.com/in/josephine-ou",
    linkedin: "",
    video: "",
    videoPreview: "",
    slides: "/assets/showcase-presentations-assets/weather-josephine-ou.pptx",
    category: "",
    showcaseDate: "11172024", //Nov 17, 2024
  },

  /////

  {
    orgName: "Clore",
    orgLogo: "/assets/showcase-presentations-assets/clore.webp",
    presenterName: "Sebastien Burkhardt",
    presenterRole: "Founder and CEO",
    presenterPhoto:
      "/assets/showcase-presentations-assets/sebastien-burkhardt.jpg",
    orgDescription: "",
    location: "Mountain View, CA, USA",
    linkedinPersonal: "",
    linkedin: "https://www.linkedin.com/company/clorefr",
    video: "",
    videoPreview: "",
    slides:
      "/assets/showcase-presentations-assets/clore-sebastien-burkhardt.pdf",
    category: "",
    showcaseDate: "11172024", //Nov 17, 2024
  },
  {
    orgName: "Komodo Fire Systems, Inc.",
    orgLogo: "/assets/showcase-presentations-assets/komodo.svg",
    presenterName: "Shawn Sahbari",
    presenterRole: "Founder and CEO",
    presenterPhoto: "", // not provided
    orgDescription: "",
    location: "",
    linkedinPersonal: "",
    linkedin: "",
    video: "",
    videoPreview: "",
    slides: "/assets/showcase-presentations-assets/komodo-shawn-sahbari.pdf",
    category: "",
    showcaseDate: "11172024", //Nov 17, 2024
  },
  {
    orgName: "Robotics Cats Limited",
    orgLogo: "/assets/showcase-presentations-assets/roboticscats.jpg",
    presenterName: "Andre Cheung",
    presenterRole: "Founder and CEO",
    presenterPhoto: "/assets/showcase-presentations-assets/andre-cheung.jpg",
    orgDescription: "",
    location: "",
    linkedinPersonal: "",
    linkedin: "https://www.linkedin.com/company/roboticscats",
    video: "",
    videoPreview: "",
    slides:
      "/assets/showcase-presentations-assets/robotics-cats-andre-cheung.pdf",
    category: "",
    showcaseDate: "11172024", //Nov 13, 2024
  },
];

export const showcasePresentersDataCWPC = [
  {
    orgName1:
      "Catastrophic Wildfire Prevention Consortium at CrowdDoing (CWPC)",
    orgName2: "CrowdDoing",
    orgLogo1: "/assets/showcase-presentations-assets/cwpc-logo.svg",
    orgLogo2: "/assets/showcase-presentations-assets/crowd-doing-logo.png",
    presenterName1: "Claudia Brenner",
    presenterRole1: "Co-CEO at CWPC, CEO at Atomic Strategic Design",
    presenterPhoto1:
      "/assets/showcase-presentations-assets/claudia-brenner.jpg",
    presenterName2: "Robert Fishkin",
    presenterRole2: " Co-CEO at CWPC, CEO & President at CrowdDowing",
    presenterPhoto2: "/assets/showcase-presentations-assets/robert-fishkin.jpg",
    orgDescription: `The Catastrophic Wildfire Prevention Consortium (CWPC) unites global experts, startups, and institutions to combat catastrophic wildfires through prevention, mitigation, and innovation. Our consortium converts the potential risks of inactions into investments in preventative actions to make communities safer, more resilient and regenerative. `,
    location1: "San Francisco, CA, USA",
    location2: "San Francisco, CA, USA",
    linkedinPersonal1: "https://www.linkedin.com/in/claudia-brenner/",
    linkedinPersonal2: "https://www.linkedin.com/in/bobbyfishkin/",
    linkedin1:
      "https://www.linkedin.com/showcase/catastrophic-wildfire-prevention-consortium/",
    linkedin2:
      "https://www.linkedin.com/company/crowddoing/posts/?feedView=all",
    video: "",
    youtube: {
      id: showcaseYoutube07162025,
      start: timeStringToSeconds("0:15:59"),
      end: timeStringToSeconds("0:28:46"),
    },
    videoPreview: "/assets/showcase-presentations-assets/cwpc-preview.jpg",
    slides:
      "/assets/showcase-presentations-assets/claudia-brenner-robert-fishkin-slides-07-16-2025.pptx",
    category: "",
    showcaseDate: "07162025", // July 16, 2025
  },
  {
    orgName1:
      "Catastrophic Wildfire Prevention Consortium at CrowdDoing (CWPC)",
    orgName2: "CrowdDoing",
    orgLogo1: "/assets/showcase-presentations-assets/cwpc-logo.svg",
    orgLogo2: "/assets/showcase-presentations-assets/crowd-doing-logo.png",
    presenterName1: "Claudia Brenner",
    presenterRole1: "Co-CEO at CWPC, CEO at Atomic Strategic Design",
    presenterPhoto1:
      "/assets/showcase-presentations-assets/claudia-brenner.jpg",
    presenterName2: "Robert Fishkin",
    presenterRole2: " Co-CEO at CWPC, CEO & President at CrowdDowing",
    presenterPhoto2: "/assets/showcase-presentations-assets/robert-fishkin.jpg",
    orgDescription: `The Catastrophic Wildfire Prevention Consortium (CWPC) unites global experts, startups, and institutions to combat catastrophic wildfires through prevention, mitigation, and innovation. Our consortium converts the potential risks of inactions into investments in preventative actions to make communities safer, more resilient and regenerative. `,
    location1: "San Francisco, CA, USA",
    location2: "San Francisco, CA, USA",
    linkedinPersonal1: "https://www.linkedin.com/in/claudia-brenner/",
    linkedinPersonal2: "https://www.linkedin.com/in/bobbyfishkin/",
    linkedin1:
      "https://www.linkedin.com/showcase/catastrophic-wildfire-prevention-consortium/",
    linkedin2:
      "https://www.linkedin.com/company/crowddoing/posts/?feedView=all",
    video: "/assets/showcase-presentations-assets/cwpc-intro-04-23-2025.mp4",
    youtube: {
      id: "4jI0sPQ19Cg",
      start: timeStringToSeconds("0:00:00"),
      end: timeStringToSeconds("0:14:40"),
    },
    videoPreview: "/assets/showcase-presentations-assets/cwpc-preview.jpg",
    slides:
      "/assets/showcase-presentations-assets/claudia-brenner-robert-fishkin-slides-04-23-2025.pptx",
    category: "",
    showcaseDate: "04232025", // April 23, 2025
  },
  {
    orgName1:
      "Catastrophic Wildfire Prevention Consortium at CrowdDoing (CWPC)",
    orgName2: "CrowdDoing",
    orgLogo1: "/assets/showcase-presentations-assets/cwpc-logo.svg",
    orgLogo2: "/assets/showcase-presentations-assets/crowd-doing-logo.png",
    presenterName1: "Claudia Brenner",
    presenterRole1: "Co-CEO at CWPC, CEO at Atomic Strategic Design",
    presenterPhoto1:
      "/assets/showcase-presentations-assets/claudia-brenner.jpg",
    presenterName2: "Robert Fishkin",
    presenterRole2: " Co-CEO at CWPC, CEO & President at CrowdDowing",
    presenterPhoto2: "/assets/showcase-presentations-assets/robert-fishkin.jpg",
    orgDescription: `The Catastrophic Wildfire Prevention Consortium (CWPC) unites global experts, startups, and institutions to combat catastrophic wildfires through prevention, mitigation, and innovation. Our consortium converts the potential risks of inactions into investments in preventative actions to make communities safer, more resilient and regenerative. `,
    location1: "San Francisco, CA, USA",
    location2: "San Francisco, CA, USA",
    linkedinPersonal1: "https://www.linkedin.com/in/claudia-brenner/",
    linkedinPersonal2: "https://www.linkedin.com/in/bobbyfishkin/",
    linkedin1:
      "https://www.linkedin.com/showcase/catastrophic-wildfire-prevention-consortium/",
    linkedin2:
      "https://www.linkedin.com/company/crowddoing/posts/?feedView=all",
    video: "/assets/showcase-presentations-assets/cwpc-intro-02-05-2025.mp4",
    videoPreview: "/assets/showcase-presentations-assets/cwpc-preview.jpg",
    youtube: { id: "I_OpBdOVA5Y", start: 333, end: 1035 },
    slides:
      "/assets/showcase-presentations-assets/claudia-brenner-robert-fishkin-slides-02-05-2025.pptx",
    category: "",
    showcaseDate: "02052025", //Feb 05, 2025
  },

  {
    orgName1:
      "Catastrophic Wildfire Prevention Consortium at CrowdDoing (CWPC)",
    orgName2: "CrowdDoing",
    orgLogo1: "/assets/showcase-presentations-assets/cwpc-logo.svg",
    orgLogo2: "/assets/showcase-presentations-assets/crowd-doing-logo.png",
    presenterName1: "Claudia Brenner",
    presenterRole1: "Co-CEO at CWPC, CEO at Atomic Strategic Design",
    presenterPhoto1:
      "/assets/showcase-presentations-assets/claudia-brenner.jpg",
    presenterName2: "Robert Fishkin",
    presenterRole2: " Co-CEO at CWPC, CEO & President at CrowdDowing",
    presenterPhoto2: "/assets/showcase-presentations-assets/robert-fishkin.jpg",
    orgDescription: `The Catastrophic Wildfire Prevention Consortium (CWPC) unites global experts, startups, and institutions to combat catastrophic wildfires through prevention, mitigation, and innovation. Our consortium converts the potential risks of inactions into investments in preventative actions to make communities safer, more resilient and regenerative. `,
    location1: "San Francisco, CA, USA",
    location2: "San Francisco, CA, USA",
    linkedinPersonal1: "https://www.linkedin.com/in/claudia-brenner/",
    linkedinPersonal2: "https://www.linkedin.com/in/bobbyfishkin/",
    linkedin1:
      "https://www.linkedin.com/showcase/catastrophic-wildfire-prevention-consortium/",
    linkedin2:
      "https://www.linkedin.com/company/crowddoing/posts/?feedView=all",
    video: "/assets/showcase-presentations-assets/cwpc-intro-11-17-2024.mp4",
    videoPreview: "/assets/showcase-presentations-assets/cwpc-preview.jpg",
    youtube: { id: "W7asMiNSEs4", start: 845, end: 1994 },
    slides:
      "/assets/showcase-presentations-assets/claudia-brenner-robert-fishkin-slides-11-17-2024.pptx",
    category: "",
    showcaseDate: "11172024", //Nov 17, 2024
  },
];

export const allShowcasesData = [
  {
    year: 2024,
    date: "11172024",
    dateShow: "November 13th, 2024",
    showcaseHeaderName: "Wildfire Innovation Showcase",
    showcaseHeaderDate: "November 13, 2025",
    fullVideo: { id: showcaseYoutube11132024 },
    videoPreview: "/assets/showcase-presentations-assets/cwpc-preview.jpg",
  },

  {
    year: 2025,
    date: "02052025",
    dateShow: "February 5th, 2025",
    showcaseHeaderName: "Wildfire Innovation Showcase",
    showcaseHeaderDate: "February 5, 2025",
    fullVideo: { id: showcaseYoutube02052025 },
    videoPreview: "/assets/showcase-presentations-assets/cwpc-preview.jpg",
  },
  {
    year: 2025,
    date: "04232025",
    dateShow: "April 23rd, 2025",
    showcaseHeaderName: "Wildfire Innovation Showcase",
    showcaseHeaderDate: "April 23, 2025",
    fullVideo: { id: showcaseYoutube04232025 },
    videoPreview: "/assets/showcase-presentations-assets/cwpc-preview.jpg",
  },

  {
    year: 2025,
    date: "07162025",
    dateShow: "July 16th, 2025",
    showcaseHeaderName: "Wildfire Innovation Showcase",
    showcaseHeaderDate: "July 16, 2025",
    fullVideo: { id: showcaseYoutube07162025 },
    videoPreview: "/assets/showcase-presentations-assets/cwpc-preview.jpg",
  },
];

/*
    https://www.youtube.com/watch?v=W7asMiNSEs4&t=1564s&ab_channel=VentureStarters (Nov 13th Showcase)
    https://www.youtube.com/watch?v=I_OpBdOVA5Y&ab_channel=VentureStarters (Feb 5th Showcase) 

    <iframe width="560" height="315" src="https://www.youtube.com/embed/W7asMiNSEs4?si=abaZD3ScAgtWhMZb" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

    <iframe width="560" height="315" src="https://www.youtube.com/embed/I_OpBdOVA5Y?si=kE8WnhFwHrP3Ezwx" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
*/

/*
{
    orgName: "BoxPower",
    orgLogo: "/assets/showcase-presentations-assets/box-power.png",
    presenterName: "Anderson Barkow",
    presenterRole: "Co-Founder",
    presenterPhoto: "/assets/showcase-presentations-assets/anderson-barkow.jpg",
    orgDescription:
      "BoxPower delivers clean, reliable, and affordable energy to rural areas through its ecosystem of software and hardware solutions. They optimize solar-plus-storage microgrids, offering turnkey engineering, construction, and management services from energy audits to operation.",
    linkedin: "https://www.linkedin.com/company/boxpower/",
    video: "",
    slides: "",
    category: "",
    showcaseDate: "02052025", //Feb 05, 2025
  },
    {
    orgName: "BoxPower",
    orgLogo: "/assets/showcase-presentations-assets/box-power.png",
    presenterName: "Anderson Barkow",
    presenterRole: "Co-Founder",
    presenterPhoto: "/assets/showcase-presentations-assets/anderson-barkow.jpg",
    orgDescription:
      "BoxPower delivers clean, reliable, and affordable energy to rural areas through its ecosystem of software and hardware solutions. They optimize solar-plus-storage microgrids, offering turnkey engineering, construction, and management services from energy audits to operation.",
    linkedin: "https://www.linkedin.com/company/boxpower/",
    video: "",
    slides: "",
    category: "",
    showcaseDate: "02052025", //Feb 05, 2025
  },
*/

export default {
  showcasePresentersData,
  showcasePresentersDataCWPC,
  allShowcasesData,
};
